import { Container, Grid, Typography, Box } from "@mui/material";
import React from "react";
import classes from "../Styles/about.module.css";
import CloseIcon from "@mui/icons-material/Close";
import ProjectCard from "../Components/ProjectCard";
import { usePortfolio } from "../Context/Portfolio";
import TechIcon from "../Components/TechIcon";

const Projects = () => {
  const { projects } = usePortfolio();
  return (
    <>
      <Container disableGutters maxWidth="xl" className={classes.about_body}>
        <Grid container className={classes.grid_container}>
          <Box
            sx={{
              height: "100%",
            }}
            className={classes.about_overflow}
          >
            <Box
              sx={{
                borderBottom: { xs: "none", md: "0.25px solid #1E2D3D" },
              }}
            >
              <Box sx={{ display: "flex" }}>
                <Typography
                  sx={{
                    color: "#607B96",
                    borderRight: "0.25px solid #1E2D3D",
                    fontSize: "16px",
                    display: { xs: "none", md: "block" },
                    fontFamily: "'Fira Code', monospace !important",
                    pt: 1.4,
                    pb: 1,
                    pl: 8,
                  }}
                >
                  {/* {!state.React && !state.HTML
                    ? "all"
                    : state.React
                    ? state.HTML
                      ? "React; Html"
                      : "React"
                    : "Html"} */}
                  My Projects
                  <CloseIcon sx={{ fontSize: "18px", pt: 0.4, pl: 4, pr: 2 }} />
                </Typography>
                <Typography
                  sx={{
                    color: "#FFFFFF",

                    fontSize: "16px",
                    display: { xs: "block", md: "none" },

                    fontFamily: "'Fira Code', monospace !important",
                    pt: 3,
                    pb: 1,
                    pl: 2,
                  }}
                >
                  {`// projects`}
                </Typography>
              </Box>
            </Box>

            <Grid
              container
              spacing={{ sm: 3, md: 6 }}
              padding={{ xs: 2, md: 8, lg: 10, xl: 18 }}
            >
              {projects.map((proj, index) => {
                return (
                  <ProjectCard
                    key={proj.id}
                    name={proj.name}
                    index={index + 1}
                    description={proj.description}
                    icon={<TechIcon tech={proj.tech} />}
                    link={proj.link}
                    image={proj.imageUrl}
                    // stateObj={state}
                  />
                );
              })}
            </Grid>
          </Box>
          {/* </Grid> */}
        </Grid>
      </Container>
    </>
  );
};

export default Projects;
